import { render, staticRenderFns } from "./fund-cluster-list.vue?vue&type=template&id=4ba17484&"
import script from "./fund-cluster-list.vue?vue&type=script&lang=js&"
export * from "./fund-cluster-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports